import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white text-gray-600 space-y-3 text-xs sm:text-sm lg:text-lg" }
const _hoisted_2 = { class: "rounded-lg p-6 flex flex-col items-center text-center space-y-4" }
const _hoisted_3 = { class: "w-9/12 h-9/12 md:w-5/12 md:h-5/12 lg:w-2/12 lg:h-2/12 rounded-full overflow-hidden border border-gray-200 shadow-lg p-6 mb-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "border border-gray-200 shadow-lg rounded-lg p-4 gap-3"
}
const _hoisted_7 = { class: "text-lg md:text-xl text-center" }
const _hoisted_8 = { class: "flex flex-col lg:flex-row lg:gap-3" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col lg:flex-row border border-gray-200 shadow-lg rounded-lg p-4 lg:gap-3 lg:w-1/2"
}
const _hoisted_10 = { class: "w-full flex flex-row space-x-3" }
const _hoisted_11 = { class: "w-full flex flex-col" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "flex flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1 lg:w-1/2" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["empresaRedSocial"]
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = { href: "{{empresaRedSocial.link}}" }
const _hoisted_20 = {
  key: 1,
  class: "w-full grid grid-cols-1 gap-4"
}
const _hoisted_21 = ["producto"]
const _hoisted_22 = { class: "grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5 border border-gray-200 shadow-lg rounded-lg p-4 gap-3 h-full" }
const _hoisted_23 = { class: "lg:col-span-1 w-full aspect-square overflow-hidden rounded-lg" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "lg:col-span-3 xl:col-span-4 flex flex-col text-justify" }
const _hoisted_26 = { class: "text-2xl" }
const _hoisted_27 = { class: "text-gray-600 mt-1" }
const _hoisted_28 = { class: "flex flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1" }
const _hoisted_29 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_30 = { class: "w-full px-2" }
const _hoisted_31 = { class: "block mb-1 text-xs" }
const _hoisted_32 = { class: "flex flex-wrap gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.empresa.previewLogo,
          class: "w-full h-full object-cover object-center"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", {
        innerHTML: _ctx.empresa.breveDescripcion,
        class: "text-justify md:text-center"
      }, null, 8, _hoisted_5)
    ]),
    (_ctx.empresa.stand)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'store'] }),
            _createTextVNode(" STAND " + _toDisplayString(_ctx.empresa.stand), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.empresa.direccion || _ctx.empresa.localidad || _ctx.empresa.provincia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'location-dot'] })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(_ctx.empresa.domicilio), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.empresa.localidad), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.empresa.provincia), 1),
                _createElementVNode("span", null, "CP : " + _toDisplayString(_ctx.empresa.codigoPostal), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.empresa.pais.descripcion), 1),
                _createElementVNode("a", {
                  href: 'tel:// ' + _ctx.empresa.mailComercial
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'phone'],
                    class: "mr-2"
                  }),
                  _createTextVNode(_toDisplayString(_ctx.empresa.telefono), 1)
                ], 8, _hoisted_12),
                (_ctx.googleMapsUrl)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.googleMapsUrl,
                      target: "_blank",
                      class: "text-blue-500 underline"
                    }, " ¿Cómo llegar? ", 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", {
            href: 'mailto: ' + _ctx.empresa.mailComercial
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['far', 'envelope'],
              class: "mr-1"
            }),
            _createTextVNode(_toDisplayString(_ctx.empresa.mailComercial), 1)
          ], 8, _hoisted_16)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empresa.empresaRedesSociales.filter(r => r.link), (empresaRedSocial) => {
          return (_openBlock(), _createElementBlock("div", {
            key: empresaRedSocial.id,
            empresaRedSocial: empresaRedSocial
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_font_awesome_icon, {
                icon: empresaRedSocial.redSocial.icono.split(' '),
                class: "mr-1"
              }, null, 8, ["icon"]),
              _createElementVNode("a", _hoisted_19, _toDisplayString(empresaRedSocial.link), 1)
            ])
          ], 8, _hoisted_17))
        }), 128))
      ])
    ]),
    (_ctx.empresa.productos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empresa.productos, (producto) => {
            return (_openBlock(), _createElementBlock("div", {
              key: producto.id,
              producto: producto
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: producto.previewFotoFile,
                    class: "w-full h-full object-cover object-center"
                  }, null, 8, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(producto.descripcion), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(producto.detalles), 1)
                ])
              ])
            ], 8, _hoisted_21))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, ([tagId, { tag, tagOpciones }]) => {
        return (_openBlock(), _createElementBlock("div", { key: tagId }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(tag.descripcion), 1),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagOpciones, (tagOpcion) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tagOpcion.id,
                    class: "px-3 py-1 bg-gray-200 rounded-lg"
                  }, _toDisplayString(tagOpcion.descripcion), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog())),
      class: "py-3 mt-2 block rounded-lg border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer text-center"
    }, [
      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] }),
      _cache[1] || (_cache[1] = _createTextVNode(" CERRAR "))
    ])
  ]))
}